import $ from 'jquery'

$(document).ready(function() {
    $('.contact-us-wrapper').height($(window).height())
})